import { combineReducers } from 'redux';
import stripeConfigReducer from './stripeconfig_reducer';
import planSubscribeReducer from './plan_subscribe_reducer';
import clientPaymentPlanReducer from './client_payment_plan_reducer';

export default combineReducers({
    stripeConfigReducer,
    planSubscribeReducer,
    clientPaymentPlanReducer,
});